import logoBrand from '@/assets/images/logo-brand-header.svg'
import { Button } from '@/components/atoms/Button/Button'
import { Logo } from '@/components/molecules/Logo/Logo'
import { useNavigate } from 'react-router-dom'
import menuMobileMenu from '@/assets/images/menu-mobile-menu.svg'
import { X } from 'lucide-react'

interface MenuMobileProps {
	closeModal: () => void
	isNotHome?: boolean
}

export function MenuMobile({ closeModal, isNotHome = false }: MenuMobileProps): JSX.Element {
	const navigate = useNavigate()

	// Función para manejar el scroll al hacer clic en los enlaces
	const handleScroll = (sectionId: string): void => {
		if (isNotHome) {
			navigate('/')
			setTimeout(() => {
				const section = document.getElementById(sectionId)
				if (section != null) {
					section.scrollIntoView({ behavior: 'smooth' })
				}
			}, 200)
		} else {
			// De lo contrario, desplázate a la sección correspondiente
			const section = document.getElementById(sectionId)
			if (section != null) {
				section.scrollIntoView({ behavior: 'smooth' })
			}
		}

		closeModal()
	}

	return (
		<header className='w-full min-w-full min-h-screen bg-[#05080E] text-white flex flex-col justify-center relative'>
			{/* Botón de cerrar */}
			<button
				onClick={closeModal}
				className='absolute top-6 right-6 text-white hover:opacity-80 z-10'
				aria-label='Close menu'
			>
				<X size={32} />
			</button>

			<img src={menuMobileMenu} alt='Menu Mobile' className='absolute bottom-0 left-0 w-[150px] h-[150px] object-cover' />
			<ul className='flex flex-col items-center gap-[3rem] p-8'>
				<li>
					<Logo
						src={logoBrand}
						alt='Lumar Prestige Logo'
						width={200}
						height={80}
					/>
				</li>
				<li>
					<button
						onClick={() => handleScroll('home')}
						className='text-white hover:opacity-80 font-light text-[16px]'
					>
						Home
					</button>
				</li>
				<li>
					<button
						onClick={() => handleScroll('aboutUs')}
						className='text-white hover:opacity-80 font-light text-[16px]'
					>
						About us
					</button>
				</li>
				<li>
					<button
						onClick={() => handleScroll('services')}
						className='text-white hover:opacity-80 font-light text-[16px]'
					>
						Services
					</button>
				</li>
				<li>
					<button
						onClick={() => handleScroll('formContactUs')}
						className='text-white hover:opacity-80 font-light text-[16px]'
					>
						Benefits
					</button>
				</li>
				<li>
					<Button
						className='bg-primary text-white font-bold hover:bg-primary-500'
						onClick={() => handleScroll('formContactUs')}
					>
						Contact
					</Button>
				</li>
			</ul>
		</header>
	)
}
